/**
 * CMS clips (node backend) for the "Add example clips" picker. Uses the app-wide
 * axios instance, which already carries the node base URL and auth header.
 */
import axios from "axios";

import type { CmsClip } from "./types";

export interface ClipSearchResult {
  items: CmsClip[];
  total?: number;
}

/** Search the org's clips (paginated) via clips API v2. */
export async function searchClips(params: {
  search?: string;
  page?: number;
  pageSize?: number;
}): Promise<ClipSearchResult> {
  const { data } = await axios.get("/stories/clips/all/v2", {
    params: {
      search: params.search || undefined,
      page: params.page || 1,
      pageSize: params.pageSize || 30,
    },
  });
  // The endpoint returns a paged envelope { items, ... }; tolerate a bare array too.
  if (Array.isArray(data)) return { items: data };
  return { items: data?.items || [], total: data?.total ?? data?.paging?.totalItems };
}

/** The story id a clip belongs to (the ref may be populated or a bare id). */
export function clipStoryId(clip: CmsClip): string | undefined {
  if (!clip.story) return undefined;
  return typeof clip.story === "string" ? clip.story : clip.story._id;
}
